/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import EnteteApercu, { HAUTEUR_ENTETE_APERCU } from './EnteteApercu';

interface ApercuTexteProps {
  /** Contenu déjà converti en texte brut. */
  texte?: string;
  titre?: string;
}

/**
 * Aperçu d'un document dont on ne dispose que du texte.
 *
 * En pratique le RTF : l'ancienne application d'état civil stockait les
 * formulaires d'acte dans ce format, qu'aucun éditeur web ne rend — on n'en
 * extrait donc que le texte, via `@mairistem/administres-rtf-parser`.
 *
 * La police à largeur fixe n'est pas un choix esthétique : ces formulaires
 * alignent leurs champs avec des espaces et des astérisques, une police
 * proportionnelle en casserait la présentation.
 */
const ApercuTexte = (props: ApercuTexteProps) => {
  const { texte, titre } = props;

  return (
    <>
      <EnteteApercu titre={titre} />
      <div
        data-testid="apercu-texte"
        style={{
          height: `calc(100% - ${HAUTEUR_ENTETE_APERCU}px)`,
          overflow: 'auto',
          border: '1px solid #dee2e6',
          borderTop: 'none',
          backgroundColor: 'white',
          padding: '1.5em',
        }}
      >
        <pre
          style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            margin: 0,
            fontFamily: 'monospace',
          }}
        >
          {texte}
        </pre>
      </div>
    </>
  );
};

export default ApercuTexte;
